import React from 'react'
import Smartview from 'widgets/smartviews/Smartview'
import {
  Collection,
  ExecuteOperationOnPipe,
  ForEachModel,
  Form,
  ModelContext,
  TriggerPipelineOnFormSubmit
} from '@morningtrain/react-resources'
import { SearchFilter } from '@morningtrain/react-filters'
import SmartviewContentSeparator from 'widgets/smartviews/partials/SmartviewContentSeparator'
import EditableSupplierCategory from 'widgets/smartviews/inventory/EditableSupplierCategory'
import { Translation, Translator } from '@morningtrain/react-translations'
import { ButtonWrap, SpaceBetween } from 'ui/layouts'
import { SquareButton } from 'ui/buttons'
import * as Icons from 'ui/icons'
import { Fieldset } from 'layouts/index'
import * as Fields from 'support/fields'
import { CallbackOnPipe, Pipeline } from '@morningtrain/react-helpers'
import ToggleAllCategories from 'widgets/smartviews/inventory/ToggleAllCategories'
import { NestedAsyncPipeline } from '@morningtrain/react-pipelines'
import { Env } from '@morningtrain/helpers'

function SupplierCategoriesSmartview () {
  const [isAdding, setIsAdding] = React.useState(false)

  const header = (
    <SpaceBetween>
      <Translation name='title' />
      {isAdding ? null : (
        <SquareButton color='btn-lightgray' onClick={() => setIsAdding(true)}>
          <Icons.Plus className='w-3' />
        </SquareButton>
      )}
    </SpaceBetween>
  )

  return (
    <Translator namespace='smartviews.supplier_categories'>
      <Smartview header={header}>
        <Collection resourceName='inventory.category' operationContext={{ context: 'smartview' }}>

          <SearchFilter />

          {!isAdding ? null : (
            <ModelContext.Provider value={null}>
              <Form resourceName='inventory.category' preventParentOperationRefresh>
                <NestedAsyncPipeline>
                  <ExecuteOperationOnPipe operationName='index' operationContext={{ context: 'smartview' }} />
                  <ExecuteOperationOnPipe operationName='index' />
                  <CallbackOnPipe callback={(payload) => {
                    Env.set('globals.inventory.supplier_categories.' + payload.response.model.id, [])
                  }}
                  />
                </NestedAsyncPipeline>
                <CallbackOnPipe callback={() => setIsAdding(false)} />

                <SmartviewContentSeparator className={['my-4']} />
                <Fieldset>
                  <Fields.Input name='name_translations.da' label='Navn (da)' />
                  <Fields.Input name='name_translations.en' label='Navn (en)' />
                </Fieldset>
                <ButtonWrap>
                  <SquareButton onClick={() => setIsAdding(false)} color='btn-white'>
                    <Icons.Decline className='w-3' />
                  </SquareButton>
                  <SquareButton color='btn-primary' type='submit'>
                    <Icons.Checkmark className='w-3' />
                  </SquareButton>
                </ButtonWrap>
              </Form>
            </ModelContext.Provider>
          )}

          <ToggleAllCategories />

          <SmartviewContentSeparator className={['my-4']} />
          <ForEachModel>
            <EditableSupplierCategory />
            <SmartviewContentSeparator className={['my-4']} />
          </ForEachModel>
        </Collection>

      </Smartview>
    </Translator>
  )
}

export default SupplierCategoriesSmartview
